import { OvertimeUploadImageWidgetFormValues } from './OvertimeUploadImageWidget';
import { OvertimeImage, OvertimeImageInput } from '../../../../globalTypes';
import { ImageUploadWithLabelFormValues } from './OvertimeUploadImageWidgetEntry/components/ImageUploadWithLabel';

export function castOvertimeUploadImageWidgetFormValuesToOvertimeImages(
  entries: OvertimeUploadImageWidgetFormValues['images'],
): OvertimeImageInput[] {
  return entries.reduce<OvertimeImageInput[]>((result, entry) => {
    if (entry.imageId) {
      return [...result, { imageId: entry.imageId, label: entry.label || undefined }];
    }

    return result;
  }, []);
}

export function castOvertimeImagesToUploadImageWidgetFormValues(
  entries: OvertimeImage[],
): OvertimeUploadImageWidgetFormValues['images'] {
  return entries.map<ImageUploadWithLabelFormValues>(({ id, label, url, thumbnail }) => ({
    orderId: Math.random().toString(36).slice(2),
    imageId: id,
    label: label || undefined,
    imageUrl: url,
    imageThumbnailUrl: thumbnail,
  }));
}
